import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ContactOpportunities from './pages/contact-opportunities';
import ProjectShowcase from './pages/project-showcase-technical-case-studies';
import TechnicalSkillsJourney from './pages/technical-skills-journey';
import HomepageInteractiveDeveloperShowcase from './pages/homepage-interactive-developer-showcase';
import CodeLaboratoryInteractivePlayground from './pages/code-laboratory-interactive-playground';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<HomepageInteractiveDeveloperShowcase />} />
        <Route path="/contact-opportunities" element={<ContactOpportunities />} />
        <Route path="/project-showcase-technical-case-studies" element={<ProjectShowcase />} />
        <Route path="/technical-skills-journey" element={<TechnicalSkillsJourney />} />
        <Route path="/code-laboratory-interactive-playground" element={<CodeLaboratoryInteractivePlayground />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
